import {isNumber, isScalar} from './types-utils';
import {IDotAccessor} from '@src/@interfaces/services/DotAccessor/IDotAccessor';

export default class DotAccessor implements IDotAccessor {
    get<TRes = any | any[]>(object: any[] | object, path: string | string[], defaultValue?: unknown): TRes {
        let result: any | any[] = object;
        let name: string | undefined;

        const chain = Array.isArray(path) ? path : String(path).split('.');

        while (name = chain.shift()) {
            if (name === '*') {
                return (
                    Array.isArray(result) ?
                        result :
                        Object.values(result)
                ).map(
                    item => this.get(item, [...chain], defaultValue)
                ) as TRes;
            }

            if (isScalar(result) || !(name in result)) {
                return defaultValue as TRes;
            }

            result = result[name];
        }

        return result;
    }

    set(object: any[] | object, path: string | string[], value: any): object | any[] {
        const chain: string[] | number[] = Array.isArray(path) ? path : path.split('.');

        let container: any | any[] = object;
        for (let i = 0; i < chain.length; i++) {
            const chainLinkName: string | number = chain[i];
            const isLastChainLink = i + 1 === chain.length;
            const nextChainLinkName = isLastChainLink ? null : chain[i + 1];

            const chainType = isNumber(nextChainLinkName || chainLinkName) ? Array : Object;
            const branchExists = container instanceof Object && chainLinkName in container;
            const containerType = branchExists ?
                (Array.isArray(container[chainLinkName]) ? Array : Object) :
                undefined;

            if (branchExists && containerType !== chainType && chainType === Object) {
                let newContainer: any | any[] = object;
                for (let j = 0; j < i; j++) {
                    newContainer = newContainer[chain[j]];
                }

                newContainer[chainLinkName] = new chainType();

                Object.keys(container).forEach(key => {
                    newContainer[key] = container[key];
                });

                container = newContainer;
            }

            if ((!branchExists || !(container[chainLinkName] instanceof Object)) && !isLastChainLink) {
                const nextChainLinkType = isNumber(nextChainLinkName) ? Array : Object;

                container[chainLinkName] = new nextChainLinkType();
            }

            if (isLastChainLink) {
                container[chainLinkName] = value;

                return object;
            }

            container = container[chainLinkName];
        }

        return object;
    }
}
